var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReturnedCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF5E00;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.3,8.5c-0.5-1.1-1.1-2-1.9-2.9c-0.8-0.8-1.8-1.5-2.9-1.9C14.4,3.2,13.2,3,12,3c-1.2,0-2.4,0.2-3.5,0.7 c-1.1,0.5-2,1.1-2.9,1.9C4.8,6.4,4.2,7.4,3.7,8.5C3.2,9.6,3,10.8,3,12c0,1.2,0.2,2.4,0.7,3.5c0.5,1.1,1.1,2,1.9,2.9 c0.8,0.8,1.8,1.5,2.9,1.9C9.6,20.8,10.8,21,12,21c1.2,0,2.4-0.2,3.5-0.7c1.1-0.5,2-1.1,2.9-1.9c0.8-0.8,1.5-1.8,1.9-2.9 c0.5-1.1,0.7-2.3,0.7-3.5C21,10.8,20.8,9.6,20.3,8.5z M17,12.3H8.3l4.2,4.2L12,17l-5-5l5-5l0.5,0.5l-4.2,4.2H17V12.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnedCircleIcon);
export default __webpack_public_path__ + "static/media/returned-circle-icon.59596c43847649c54d10fdb3c3395f27.svg";
export { ForwardRef as ReactComponent };